import moment from 'moment';

export const getFullDate = date => {
	if (!date) {
		return '';
	}

	const d = new Date(date);

	return d.toISOString().split('T')[0];
};

export const getLastRunFormatted = round => {
	if (round.activeHistory) {
		return moment(round.lastRun).format('YYYY-MM') + '-01';
	}

	if (round.lastRun) {
		let date = null;
		switch (round.intervalType) {
		case 0:
			date = moment(round.lastRun).add(
				round.intervalValue,
				'minutes'
			);

			return date.format('YYYY-MM-DD');
		case 1:
			date = moment(round.lastRun).add(round.intervalValue, 'hours');

			return date.format('YYYY-MM-DD');
		case 2:
			date = moment(round.lastRun).add(round.intervalValue, 'days');

			return date.format('YYYY-MM-DD');
		case 3:
			date = moment(round.lastRun).add(
				round.intervalValue,
				'months'
			);

			return date.format('YYYY-MM') + '-01';
		case 4:
			date = moment(round.lastRun).add(round.intervalValue, 'years');

			return date.format('YYYY') + '-01-01';
		}

		return date.format('YYYY-MM-DD');
	}

	return moment(round.start).format('YYYY-MM-DD');
};

export const lastCheckedFormatted = round => {

	return moment(round).format('YYYY-MM-DD');
};
